const BASE_URL = 'https://www.justwatch.com';

export default function jwPageUrl (path) {
  return `${BASE_URL}${path}`;
}
